import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const List = styled.ul`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: 0;
  margin: 0;

  list-style: none;
`;

export const ListItem = styled.li``;

export const AddButton = styled.button`
  ${({ theme }) => typographyToCss(theme.typography.button)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  width: 100%;
  padding: 0;
  margin: 0;

  border: none;
  background: none;
  cursor: pointer;

  color: ${({ theme }) => theme.palette.info.main};
`;

export const AddIconContainer = styled.span`
  font-size: 1.6rem;
  line-height: 62.5%;
`;
